import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';

import type { Command } from './types';

import { Text, useTheme } from '@/components/ui';

interface CommandResultItemProps {
	command: Command;
	isSelected?: boolean;
	onPress: () => void;
}

export const CommandResultItem: React.FC<CommandResultItemProps> = ({
	command,
	isSelected = false,
	onPress,
}) => {
	const theme = useTheme();

	return (
		<TouchableOpacity
			onPress={onPress}
			style={[
				styles.listItem,
				{
					backgroundColor: isSelected ? theme.colors.primaryContainer : theme.colors.surface,
					borderBottomColor: theme.colors.outline,
				},
			]}
		>
			<View style={styles.listItemContent}>
				<View style={[
					styles.listItemIcon,
					{
						backgroundColor: isSelected ? theme.colors.primary : '#f5f5f5',
					},
				]}>
					<Ionicons
						name={command.icon}
						size={24}
						color={isSelected ? theme.colors.onPrimary : theme.colors.primary}
					/>
				</View>
				<View style={styles.listItemText}>
					<Text
						variant="bodyLarge"
						style={{
							fontWeight: '600',
							color: isSelected ? theme.colors.onPrimaryContainer : theme.colors.onSurface,
						}}
					>
						{command.title}
					</Text>
					<Text
						variant="bodyMedium"
						style={{
							color: isSelected ? theme.colors.onPrimaryContainer : theme.colors.onSurfaceVariant,
						}}
					>
						{command.description}
					</Text>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 4 }}>
						<Text
							variant="labelSmall"
							style={{
								color: isSelected ? theme.colors.primary : theme.colors.primary,
							}}
						>
							Command
						</Text>
					</View>
				</View>
			</View>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	listItem: {
		padding: 16,
		borderBottomWidth: 1,
		borderBottomColor: '#e0e0e0',
	},
	listItemContent: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	listItemIcon: {
		marginRight: 12,
		width: 40,
		height: 40,
		borderRadius: 20,
		backgroundColor: '#f5f5f5',
		justifyContent: 'center',
		alignItems: 'center',
	},
	listItemText: {
		flex: 1,
	},
});
